<template>
  <div class="content">
    <aside class="aside">
      <strong>{{ $t('app.transfer.notes.title') }}</strong>
      <br />1. 卡分配只能分配本账户下未分配的组网数据。
      <br />2. 已分配的组网数据需先操作卡回收，再重新分配。
      <br />3. 组网数据分配提交后，请前往任务中心查看分配进度和结果。
      <br />4. 如有疑问请联系客服或销售人员。
    </aside>
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :rules="rules" class="ruleForm">
      <el-form-item :label="$t('app.transfer.agent')" prop="userId" label-width="151px" :rules="[{ required: isAgentRequired, message:$t('app.transfer.validate.agentRequired'), trigger: 'blur'}]">
        <el-cascader
          :placeholder="$t('app.transfer.selectAgent')"
          ref="myCascader"
          :options="agentoptions"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          style="width: 460px"
          v-model="ruleForm.userId"
          filterable
        ></el-cascader>
      </el-form-item>

      <el-form-item label="组网号/ICCID" prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          :placeholder="$t('app.transfer.iccidsPlaceholder')"
          rows="6"
          @input="changeAllocationIccids"
          style="width:460px;font-size:14px"
        ></el-input>
        <div class="card-num" v-if="allocationIccidsCount>0"><span>总数：</span><span>{{allocationIccidsCount}}</span></div>
      </el-form-item>
      <el-form-item label="组网号/ICCID范围" prop="startIccid" label-width="151px">
        <el-input
          v-model="ruleForm.startIccid"
          style="width: 220px;margin-right: 10px;"
          clearable
          placeholder="起始组网号/ICCID"
          @input="changeAllocationIccidRangeCount"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="ruleForm.endIccid"
          style="width: 220px;margin-left: 10px;"
          clearable
          placeholder="结束组网号/ICCID"
          @input="changeAllocationIccidRangeCount"
        ></el-input>
        <div class="card-num" v-if="allocationIccidRangeCount>0"><span>总数：</span><span>{{allocationIccidRangeCount}}</span></div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="submitForm('ruleForm')" >{{ $t('app.common.submit') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { agentTreeList  } from "@/api/api.js"; //获取代理商的数据
import { selectCount , assignCard } from "@/api/api.js"; //卡分配的提交
export default {
  name:"multiNetAllocation",
  data() {
    return {
      ruleForm: {
        type:"1",
        fieldType:"1",
        userId:undefined,
        username:undefined,
        iccids:'',
        startIccid:undefined,
        endIccid:undefined,
        serviceProviderId:undefined,
        status:'0',
        simProduct:'0',
        schemeId:undefined
      },
      allocationIccidsCount:0,
      allocationIccidRangeCount:0,
      isAgentRequired: true,
      agentoptions: [],
      submitLoading:false,
      commissionModel:"0",
      rules: {
        userId: [
          { required: true, message: this.$t('app.transfer.validate.agentRequired'), trigger: "blur" },
        ]
      },
    };
  },
  watch:{
    $route: {
      handler: function(to, from){
        if(to.name == 'multiNetAllocation'){
          let arrIccids = this.$route.params.iccids || []
          if(arrIccids.length>0){
            this.$set(this.ruleForm,"iccids",this.$route.params.iccids);
            this.changeAllocationIccids()
          }
          this.handleAgentTreeList();
        }
      },
      deep: true,
      immediate:true
    }
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
  },
  methods: {
    submitForm() {
      let { iccids } = this.ruleForm;
      let params = {
        ...this.ruleForm,
        iccids:iccids ? iccids.split("\n") : []
      };
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          assignCard(params).then(res => {
              this.$notify.info({
                title: this.$t('app.common.tip'),
                message: this.$t('app.transfer.submit.success'),
                duration: 1000,
                offset:30
              });
              
              setTimeout(()=>{
                // 保留原对象引用，逐个重置属性以保持 Vue 2 响应式
                this.ruleForm.fieldType = '1'
                this.ruleForm.userId = undefined
                this.ruleForm.username = undefined
                this.ruleForm.iccids = ''
                this.ruleForm.startIccid = undefined
                this.ruleForm.endIccid = undefined
                // 仅在下拉选择模式下才重置 cascader，避免 switchInput 为 true 时 myCascader 不存在导致报错
                if (this.$refs.myCascader) {
                  this.$refs.myCascader.$refs.panel.clearCheckedNodes();
                  this.$refs.myCascader.$refs.panel.activePath = [];
                }
                this.allocationIccidsCount = 0
                this.allocationIccidRangeCount = 0
                this.$router.push({ path: `/taskCenter/missionList`});
              },1000)
          })
        }
      });
    },
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentoptions = res.data.data;
      });
    },
    changeAllocationIccids(){
      let arrIccids = this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      this.allocationIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeAllocationIccidRangeCount(){
      this.allocationIccidRangeCount = 0
      let fieldType = this.ruleForm.fieldType
      if(!!this.ruleForm.startIccid && !!this.ruleForm.endIccid){
            if(this.ruleForm.fieldType === '1'  && this.ruleForm.startIccid.length>8 && this.ruleForm.endIccid.length>8){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.allocationIccidRangeCount = res.data.data
              })
            }
            if(this.ruleForm.fieldType === '2'  && this.ruleForm.startIccid.length>8 && this.ruleForm.endIccid.length>8){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.allocationIccidRangeCount = res.data.data
              })
            }
      }

    }
  },

  created() {
    this.handleAgentTreeList();
    if(this.adminShow){
      this.allocationIccidRangeCount = 0
      let arrIccids = this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      this.allocationIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeAllocationIccidRangeCount()
    }
  },
};
</script>
<style scoped lang="less">
  .card-num{
    height: 20px;
    line-height: 20px;
    span:nth-of-type(2){
      color:red
    }
  }
  .aside {
    background: #eef1f6;
    padding: 8px 24px;
    margin-bottom: 20px;
    border-radius: 2px;
    display: block;
    line-height: 32px;
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    color: #2c3e50;
    -webkit-font-smoothing: antialiased;
    margin-left: 20px;
    width: 50%;
  }
  .aspan{
    display: inline-block;
    width: 18px;
  }
</style>
